import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    // /coupons/list supports: active, restaurantId, limit, offset (per documentation)
    return buildApiUrl(ADMIN_ENDPOINTS.ADMIN_COUPONS || '/coupons/list', {
      queryParams: {
        active: payload?.active !== undefined ? payload.active : undefined,
        restaurantId: payload?.restaurantId || undefined,
        // limit: payload?.limit || undefined,
        // offset: payload?.offset || undefined,
      }
    })
  },

  parse(raw = {}, payload = {}) {
    if (raw.statusCode !== 200) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch coupons',
        data: null,
      }
    }

    // /coupons/list returns data: { data: [...], total } per documentation
    const res = raw.data || {}
    const coupons = Array.isArray(res) ? res : (Array.isArray(res.data) ? res.data : [])

    const formatted = coupons.map(el => ({
      id: el.id,
      code: el.code,
      type: el.type,
      discount: el.discount,
      minOrderAmount: el.minOrderAmount,
      maxDiscountAmount: el.maxDiscountAmount,
      description: el.description,
      storeId: el.restaurantId || 'all',
      startDate: el.validFrom,
      endDate: el.validTo,
      nbAppliance: el.usageLimit,
      userLimit: el.userLimit || 1,
      usageCount: el.usageCount,
      isActive: el.active,
      isVisible: el.isVisible !== undefined ? el.isVisible : true,
      status: el.active ? 'active' : 'inactive',
      title: el.metadata?.title || '',
      merchandSupportDiscount: el.metadata?.merchandSupportDiscount || false
    }))

    let data = formatted
    // === Recherche textuelle locale ===
    const searchTerm = (payload?.search || '').toString().trim().toLowerCase()
    if (searchTerm) {
      data = data.filter(el => {
        return Object.values(el).some(val => 
          val && typeof val !== 'object' && String(val).toLowerCase().includes(searchTerm)
        )
      })
    }

    // === Tri dynamique selon payload.sortKey et sortOrder ===
    const { sortKey, sortOrder } = payload || {}
    if (sortKey) {
      const order = sortOrder === 'desc' ? -1 : 1
      data = [...data].sort((a, b) => {
        const valA = a?.[sortKey]
        const valB = b?.[sortKey]
        if (typeof valA === 'string' && typeof valB === 'string') return valA.localeCompare(valB) * order
        if (typeof valA === 'number' && typeof valB === 'number') return (valA - valB) * order
        return 0
      })
    }

    // === Pagination locale ===
    const { page = 0, limit = 20 } = payload || {}
    const paginated = data.slice(page * limit, (page + 1) * limit)

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        total: searchTerm ? data.length : (res.total || formatted.length),
        result: paginated,
      },
    }
  },
}
